import { useQuery, useMutation, QueryFunction } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useFetchWithAuth } from '../session/useFetchWithAuth'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

export const useSuggestKeywordsMutation = () => {
  const fetchWithAuth = useFetchWithAuth()

  return useMutation({
    mutationFn: async (data: { userId: string; description: string }) => {
      const response = await fetchWithAuth(
        `${URL}/profile/${data.userId}/suggest-keywords`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            userId: data.userId,
            description: data.description,
          }),
        }
      )
      return response as { id: number; keyword: string }[]
    },
    onError: (error) => {
      console.error('Update profile error:', error)
      toast.error(error.message)
    },
  })
}
